import { createContext, Dispatch, SetStateAction } from 'react';

export interface User {
    id: string;
    token: string;
    name: string;
    email: string;
    photo: string;
    speaker_id: string;
    picture: string;
    is_moderator: boolean;
    is_speaker: boolean;
    is_association: boolean;
    disabled: boolean;
    moderator: boolean;
    external_id: string;
}

const UserContext = createContext<{
    user: null | User, // profile
    setUser: Dispatch<SetStateAction<null | User>>,
    showLogin: boolean,
    setShowLogin: Dispatch<SetStateAction<boolean>>,
    oneTimeShowLogin: boolean,
    setOneTimeShowLogin: Dispatch<SetStateAction<boolean>>,
    redirectPath: string,
    setRedirectPath: Dispatch<SetStateAction<string>>,
    currentEvent: any,
    setCurrentEvent: Dispatch<SetStateAction<any>>,
    listUser: string, // token
    setListUser: Dispatch<string>,
    authHeader: string,
    setAuthHeader: Dispatch<string>,
}>({
    user: null,
    setUser: () => null,
    showLogin: true,
    setShowLogin: () => null,
    oneTimeShowLogin: true,
    setOneTimeShowLogin: () => null,
    redirectPath: "",
    setRedirectPath: () => null,
    currentEvent: null,
    setCurrentEvent: () => null,
    listUser: "",
    setListUser: () => null,
    authHeader: "",
    setAuthHeader: () => null,
});

export default UserContext;
